import PropTypes from 'prop-types';
import React from 'react';

// Styles.
import './modal-overlay.scss';

const ModalOverlay = ({ dismiss }) => (
  <div
    aria-label="Close"
    className="kauffman-modal-overlay"
    onClick={dismiss}
    onKeyUp={(event) => 'Escape' === event.key && dismiss()}
    role="button"
    tabIndex="0"
  />
);

ModalOverlay.propTypes = {
  dismiss: PropTypes.func.isRequired,
};

export default ModalOverlay;
